import React from "react";
import { InstructionOfBestExecutionSV as SV } from "./InstructionOfBestExecutionSV";
import { InstructionOfBestExecutionEN as EN } from "./InstructionOfBestExecutionEN";
import "../../Documents.css";
const docsMap = { SV, EN };
export const InstructionOfBestExecution = props => React.createElement(docsMap[props.language], null);
